"use strict"

document.addEventListener(
  "DOMContentLoaded",

  function () {
    // inject style and content of coming soon badge
    const comingSoon = document.querySelectorAll(".comingSoonBadge2")
    comingSoon.forEach(item => {
      item.style = ""
      item.classList.add("product-comingsoon")
    })

    // svg bin icon in cart

    const removeButtons = document.querySelectorAll(".cart-item__remove")
    removeButtons.forEach(item => {
      const removeButton = item
      removeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="32" height="32" fill="none" viewBox="0 0 32 32"><path stroke="#3F3200" stroke-linecap="round" stroke-linejoin="round" d="M27 7H5M13 13v8M19 13v8M25 7v19a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7M21 7V5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v2"/></svg><span class="visually-hidden">Quitar</span>`
    })

    // inject text and css around the available from date in product detail

    const availableFromGS = document.querySelector("#availablefromGS")
    const availableFromGSdiv = document.createElement("div")

    availableFromGSdiv.innerHTML = availableFromGS.innerHTML
    availableFromGS.parentNode.replaceChild(availableFromGSdiv, availableFromGS)
    availableFromGSdiv.classList.add("availablefromGSdiv")

    availableFromGSdiv.innerHTML = `
    <h3>¿Cuándo me llegará?</h3>
    <p>Este producto estará en stock desde<strong>${availableFromGSdiv.innerHTML}</strong>. <br />
    A partir de ahí, necesitamos 48/72h para que llegue a tu casa. </p>
    <h3>¿Qué es Pre-Order?</h3>
    <p>Son productos que no tenemos en stock en estos momentos pero que se están fabricando. Solo necesitamos un poco más de tiempo para que lo tengas en tu casa.</p>`
  },
  false,
)

// open external social links in new tab
var links = document.links
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank"
    links[i].rel = "noreferrer noopener"
  }
}

// aninmation to show that something was put in or deleted fron wishlist

const wlHeaderIcon = document.querySelector(".header-wl-heart")
const wlProductIcon = document.querySelectorAll(".wishlisthero-floating")

console.log(wlProductIcon)

wlProductIcon.forEach(item => {
  item.addEventListener("click", function () {
    if (item.querySelector(".wishlisthero-product-in-wishlist")) {
      wlHeaderIcon.classList.add("inWishlistHeart--delete")

      // set interval to remove class after 1 second
      setTimeout(function () {
        wlHeaderIcon.classList.remove("inWishlistHeart--delete")
      }, 1000)
    } else {
      wlHeaderIcon.classList.add("inWishlistHeart--active")

      // set interval to remove class after 1 second
      setTimeout(function () {
        wlHeaderIcon.classList.remove("inWishlistHeart--active")
      }, 1000)
    }
  })
})

// check if carrito selector has only one option and add a message in a span
const optionSelectorLabel = document.querySelector(".option-selector label")
const onlyChild = document.querySelector("ul.cc-select__listbox li:only-child")

if (onlyChild) {
  const span = document.createElement("span")
  span.textContent = "(Por favor asegúrate que el producto es compatible con tu modelo de carrito.)"
  optionSelectorLabel.appendChild(span)
}
